var English = "Inggris";
var French = "Prancis";
var German = "Jerman";
var Italian = "Italia";
var Japanese = "Jepang";
var Korean = "Korea";
var Portuguese = "Portugal";
var Russian = "Rusia";
var Spanish = "Spanyol";
var Bahasa = "Indonesia";
var Thai = "Thai";
var Vietnamese = "Vietnam";
var Turkish = "Turki";
var Arabic = "Arab";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Tionghoa Sederhana",
	"Chinese-Traditional": "Tionghoa Tradisional",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
